<template>
  <draggable tag="div"
             class="v-gallery v-gallery--inspections"
             :class="{ 'v-gallery--has-any-selected': !!selected }"
             v-bind="{ group: 'groups', draggable: isDraggable, delay: 400, delayOnTouchOnly: true, touchStartThreshold: 3, fallbackTolerance: 3, filter: selectorIsFiltered }"
             v-model="dataCollection"
             @update="$emit('reorder-group', dataCollection.map(i => i.id), galleryMemberId); $emit('reorder', reorder())">
    <div class="v-gallery__group" v-for="group in dataCollection" :key="group.id">
      <ul class="form__list form__list--align-to-top">
        <li :class="['form__item','form__item--1/2']">
          <div>
            <div class="v-gallery__header-block">
              <div class="v-gallery__tools v-gallery__tools--inspections" v-if="toolbar">
                <a @click="toggleToolbar(group.id)" style="cursor:pointer;" v-if="editButton">
                  <img style="vertical-align: top;" src="/images/cms_wijzigen.png" />
                </a>
                <a @click="$emit('delete-group', group.id, galleryMemberId)"
                   style="cursor:pointer;"
                   v-if="removeButton">
                  <img style="vertical-align: top;" src="/images/cms_verwijderen.png" />
                </a>
                <slot name="extra" :group="group"></slot>
              </div>
              <slot name="header" :group="group">
                <h3 class="v-gallery__heading">{{ group[groupName] }}</h3>
              </slot>
              <div v-if="group.toolbar">
                <slot name="toolbar" :item="group"></slot>
              </div>
            </div>

            <div class="loader-bar" v-if="showLoaderFor === group.id"></div>

            <draggable tag="ul"
                       class="v-gallery__list"
                       :draggable="selector"
                       v-model="group[items]"
                       v-bind="{ group: 'items', delay: 400, delayOnTouchOnly: true, touchStartThreshold: 3, fallbackTolerance: 3 }"
                       @update="$emit('reorder-item', group[items].map(i => i.id), group.id, galleryMemberId); $emit('reorder', reorder())"
                       @add="$emit('reorder-outer-item', group[items].map(i => i.id), group.id, galleryMemberId)"
                       @change="$event.removed || $event.added ? $emit('change', $event, group.id, galleryMemberId) : null">
              <template v-for="item in group[items]">
        <li class="v-gallery__item v-gallery__item--draggable"
            :class="{ 'v-gallery__item--is-selected': selected === item }"
            :key="item.id">
          <div class="v-gallery__holder">
            <div class="v-gallery__inner">
              <slot :gallery-id="galleryMemberId"
                    :item="item"
                    :group="group"
                    :groupheader="group[groupName]"
                    :is-selected="selected === item"></slot>
            </div>
          </div>
          <v-lightcase-holder :image-src="item.url"
                              :name="`lightcase-${item.id}`"
                              :download-link="item.fileUrl"
                              :current-document="item"
                              :disable-rotate="disableRotate"
                              :details="group"></v-lightcase-holder>
        </li>
    </template>
    <li :for="`file${group.id}`"
        class="v-gallery__item v-gallery__item-to-drop"
        v-if="!selected"
        @click="triggerFileInputClick(`fileInput${group.id}`)"
        @dragover="resetEvent($event)"
        @dragleave="resetEvent($event)"
        @drop="handleUpload($event, group.id, galleryMemberId)">

    <div class="v-gallery__holder">
      <div class="v-gallery__inner">
        <div class="v-gallery__plus">+</div>
      </div>
    </div>
</li>
            </draggable>
<input type="file"
       v-if="acceptImages"
       multiple
       @change="handleUpload($event, group.id, galleryMemberId)"
       accept="image/*"
       v-show="false"
       :ref="`fileInput${group.id}`" />
<input type="file"
       v-else
       multiple
       @change="handleUpload($event, group.id, galleryMemberId)"
       v-show="false"
       :ref="`fileInput${group.id}`" />

<div class="mt-3" v-else-if="group[items].includes(selected)">
  <slot name="toolbar" :selected="selected" :facility="group"></slot>
</div>
          </div>
        </li>
<li class="form__item form__item--1/2">
  <slot name="editor" :group="group"></slot>
</li>
      </ul>
<ul class="form__list form__list--align-to-top l-s-hlp" v-if="group.tenant_photos.length || group.tenant_description">
  <li class="form__item form__item--1/2" v-if="group.tenant_photos.length">
    <slot name="tenantPhotos" :group="group"></slot>
  </li>
  <li class="form__item form__item--1/2" v-if="group.tenant_description">
    <slot name="tenantEditor" :group="group"></slot>
  </li>
</ul>
<div v-if="group.addForm" style="display: flex;">
  <slot name="add-form" :item="group"></slot>
</div>
    </div>
  </draggable>
</template>

<script>
  import _ from "lodash";
  import draggable from "vuedraggable";
  import "lightcase/src/css/lightcase.css";
  import configureLightcase from "../../lightcase.js";
  import VLightcaseHolder from "./VLightcaseHolder";

  export default {
    components: {
      draggable,
      VLightcaseHolder
    },
    data() {
      return {
        selected: null,
        dataCollection: Object.assign([], this.collection),
        isDraggable: this.disableDragAndDrop
          ? ".none-of-current-items-draggable"
          : ".v-gallery__group",
        selector: window.app.methods.isTouchDevice() ? ".v-gallery__item--draggable" : ".v-gallery__item",
        selectorIsFiltered: window.app.methods.isTouchDevice() ? '.v-gallery__item-to-drop' : ''
      };
    },
    methods: {
      reorder() {
        return this.dataCollection.map(group => {
          let groupItems = {};
          groupItems[group.id] = group[this.items].map(i => i.id);
          return groupItems;
        });

        //return _.zipObject(this.dataCollection.map(i => i.id), this.dataCollection.map(i => i[this.items].map(i => i.id)));
      },
      toggleToolbar(groupId) {
        let currentGroupIndex = this.dataCollection.findIndex(item => {
          return item.id === groupId;
        });
        let currentGroup = this.dataCollection[currentGroupIndex];
        currentGroup.toolbar = !currentGroup.toolbar;
        this.dataCollection[currentGroupIndex] = {
          ...currentGroup
        };
        this.$emit("toolbar-toggled", {
          index: currentGroupIndex,
          state: !!currentGroup.toolbar
        });
        this.dataCollection = [...this.dataCollection];
      },
      resetEvent(event) {
        if (!window.app.methods.isTouchDevice()) {
          event.stopPropagation();
          event.preventDefault();
        }
      },
      toggleAddForm(groupId) {
        let currentGroupIndex = this.dataCollection.findIndex(item => {
          return item.id === groupId;
        });
        let currentGroup = this.dataCollection[currentGroupIndex];
        currentGroup.addForm = !currentGroup.addForm;
        this.dataCollection[currentGroupIndex] = {
          ...currentGroup
        };
        this.dataCollection = [...this.dataCollection];
      },
      triggerFileInputClick(ref) {
        this.$refs[ref][0].click();
      },
      handleUpload(event, groupId, galleryId) {
        event.preventDefault();
        event.stopPropagation();
        let files;
        if (
          event.dataTransfer &&
          event.dataTransfer.files &&
          event.dataTransfer.files.length
        ) {
          files = event.dataTransfer.files;
          this.$emit("upload", files, groupId, galleryId);
        } else if (
          event.target &&
          event.target.files &&
          event.target.files.length
        ) {
          files = event.target.files;
          this.$emit("upload", files, groupId, galleryId);
        }
      }
    },
    props: {
      collection: {
        default: () => [],
        type: Array
      },
      galleryMemberId: {
        default: 0,
        type: Number
      },
      items: {
        default: "items",
        type: String
      },
      groupName: {
        default: "name",
        type: String
      },
      toolbar: {
        default: false,
        type: Boolean
      },
      addForm: {
        default: false,
        type: Boolean
      },
      editButton: {
        default: true,
        type: Boolean
      },
      removeButton: {
        default: true,
        type: Boolean
      },
      disableRotate: {
        default: false,
        type: Boolean
      },
      showLoaderFor: {
        default: 0,
        type: Number
      },
      disableDragAndDrop: {
        default: false,
        type: Boolean
      },
      acceptImages: {
        default: false,
        type: Boolean
      }
    },
    watch: {
      collection(value) {
        this.dataCollection = value;
      }
    },
    created() {
      let that = this;

      this.$root.$on("remove-item-photos", (index) => {
        that.dataCollection[index].ordered_photos = [];
      });

      this.$root.$on("remove-all-photos", () => {
        that.dataCollection.forEach(item => {
          item.ordered_photos = [];
        });
      });
    },
    beforeMount() {
      configureLightcase();
    },
    beforeUpdate() {
      configureLightcase();
    },
    updated() {
      this.$root.$emit("galleryUpdated");
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/admin/components/VGalleryInspectionsPublic.vue